import "assets/style/index.scss";

import React from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from "react-router-dom";

import HotWire from "hot-wire";
import { Provider } from "react-hot-wire";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "./i18n/i18n";

import { ThemeProvider } from "@material-ui/styles";

import services from "services";

import { theme } from "components/theme";
import InitConfiguration from "components/common/init/Configuration";
import InitAuthorization from "components/common/init/Authorization";

import Wrapper from "components/common/wrapper/Wrapper";

import ActiveApplicationList from "components/application/list/active/List";
import ArchivedApplicationList from "components/application/list/archived/List";

import PrizeSupplierList from "components/prize/supplier/list/List";
import PrizeList from "components/prize/prize/list/List";
import PrizeOrderList from "components/prize/order/list/List";

import JobList from "components/job/list/List";

import * as serviceWorker from "./serviceWorker";
import CategoryList from "./components/prize/category/list/List";

const hotWire = new HotWire();
const queryClient = new QueryClient();

(async () => {
  const resolvedServices = await hotWire.wire({ services });

  await resolvedServices.siteService.init();

  ReactDOM.render(
    <Provider services={resolvedServices}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <InitConfiguration>
            <Router>
              <Switch>
                <Route exact path="/auth/login" />
                <InitAuthorization>
                  <Wrapper>
                    <Switch>
                      <Route
                        exact
                        path="/application/list/active"
                        component={ActiveApplicationList}
                      />
                      <Route
                        exact
                        path="/application/list/archived"
                        component={ArchivedApplicationList}
                      />
                      <Route
                        exact
                        path="/prize/supplier/list"
                        component={PrizeSupplierList}
                      />
                      <Route
                        exact
                        path="/prize/category/list"
                        component={CategoryList}
                      />
                      <Route exact path="/prize/list" component={PrizeList} />
                      <Route
                        exact
                        path="/prize/order/list"
                        component={PrizeOrderList}
                      />
                      <Route exact path="/job/list" component={JobList} />
                      <Redirect exact from="/" to="/application/list/active" />
                      <Route exact path="/auth/logout" />
                    </Switch>
                  </Wrapper>
                </InitAuthorization>
              </Switch>
            </Router>
          </InitConfiguration>
        </ThemeProvider>
      </QueryClientProvider>
    </Provider>,
    document.getElementById("root")
  );
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
